var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"app"},[(_vm.showAppBar)?_c('AppBar'):_vm._e(),_c('v-main',{class:{
      'pt-15': _vm.showAppBar
    }},[(_vm.showPageLoading)?_c('PageLoading',{attrs:{"loadingText":_vm.loadingText}}):_vm._e(),(!_vm.showPageLoading)?_c('router-view'):_vm._e()],1),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }